// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".privacy[data-v-dfa917ba]{padding-bottom:20px;background:#fff}.privacy__container[data-v-dfa917ba]{align-items:flex-start!important}a[data-v-dfa917ba],a[data-v-dfa917ba]:active,a[data-v-dfa917ba]:hover,a[data-v-dfa917ba]:link,a[data-v-dfa917ba]:visited{color:initial;display:inline}", ""]);
// Exports
module.exports = exports;
